<div [class]="'full-height ui-app ui-app--' + (theme || 'default')" [class.ui-sidebar-open]="ui.sidebar.isOpen">
  <ng-content></ng-content>
</div>
